export enum MMLElementType {
  CUBE = 'm-cube',
  SPHERE = 'm-sphere',
  MODEL = 'm-model',
  GROUP = 'm-group',
  AUDIO = 'm-audio',
  LABEL = 'm-label',
  CYLINDER = 'm-cylinder',
  LIGHT = 'm-light',
  PLANE = 'm-plane',
  IMAGE = 'm-image',
  VIDEO = 'm-video',
}

export interface CommonAttributes {
  id?: string;
  x?: number;
  y?: number;
  z?: number;
  rx?: number;
  ry?: number;
  rz?: number;
  sx?: number;
  sy?: number;
  sz?: number;
  color?: string;
  class?: string;
}

export interface CubeAttributes extends CommonAttributes {}

export interface SphereAttributes extends CommonAttributes {}

export interface ModelAttributes extends CommonAttributes {
  src: string;
}

export interface GroupAttributes extends CommonAttributes {}

export interface AudioAttributes extends CommonAttributes {
  src: string;
  'start-time'?: number;
  loop?: boolean;
}

export interface LabelAttributes extends CommonAttributes {
  content: string;
  'font-size'?: number;
  width?: number;
  height?: number;
  alignment?: string;
  'font-color'?: string;
  onclick?: string;
}

export interface CylinderAttributes extends CommonAttributes {}

export interface LightAttributes extends CommonAttributes {
  type: string;
  intensity?: string | number;
}

export interface PlaneAttributes extends CommonAttributes {
  width?: number;
  height?: number;
}

export interface ImageAttributes extends CommonAttributes {
  src: string;
  width?: number;
  height?: number;
}

export interface VideoAttributes extends CommonAttributes {
  src: string;
  width?: number;
  height?: number;
  'start-time'?: number;
  loop?: boolean;
}

export interface ValidationError {
  line: number;
  column: number;
  message: string;
  type: 'error' | 'warning';
  element?: string;
  attribute?: string;
}

export interface ValidationResult {
  isValid: boolean;
  errors: ValidationError[];
  parsedElements?: MMLElement[];
}

export interface MMLElement {
  type: MMLElementType;
  attributes: Record<string, string | number | boolean>;
  children: MMLElement[];
  parent?: MMLElement;
  line: number;
  column: number;
  rawContent: string;
}
